import React, { ReactElement, useCallback } from 'react';
import { Button } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

export const Roadmap = (values) => {
  const generateRoadMap = useCallback(() => {}, [values]);

  return (
    <>
      <Tooltip title={'Not Available'}>
        <Button
          disabled={true}
          onClick={() => {
            generateRoadMap();
          }}
          variant={'contained'}
        >
          ROADMAP
        </Button>
      </Tooltip>
    </>
  );
};
